/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
    ErrorHttpContentDto,
    InstitutionCheckExceptionReturnReasonCollectionDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class InstitutionCheckExceptionReturnReasonClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags InstitutionCheckExceptionReturnReason
   * @name InstitutionCheckExceptionReturnReasonGetInstitutionCheckExceptionReturnReason
   * @summary Retrieve all of the Check Exception Return Reasons for the current users institution.
   * @request GET:/InstitutionCheckExceptionReturnReason
   */
  institutionCheckExceptionReturnReasonGetInstitutionCheckExceptionReturnReason =
    (params: RequestParams = {}) =>
      this.http.request<
        InstitutionCheckExceptionReturnReasonCollectionDto,
        ErrorHttpContentDto
      >({
        path: `/InstitutionCheckExceptionReturnReason`,
        method: "GET",
        format: "json",
        ...params,
      });
  /**
   * No description
   *
   * @tags InstitutionCheckExceptionReturnReason
   * @name InstitutionCheckExceptionReturnReasonSaveInstitutionCheckExceptionReturnReason
   * @summary Saves the collection of Check Exception return reasons and returns an updated version of the collection.
   * @request POST:/InstitutionCheckExceptionReturnReason
   */
  institutionCheckExceptionReturnReasonSaveInstitutionCheckExceptionReturnReason =
    (
      data: InstitutionCheckExceptionReturnReasonCollectionDto,
      params: RequestParams = {},
    ) =>
      this.http.request<
        InstitutionCheckExceptionReturnReasonCollectionDto,
        ErrorHttpContentDto
      >({
        path: `/InstitutionCheckExceptionReturnReason`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      });
}
